import { Routes, RouterModule } from '@angular/router';
import { HolidayComponent } from './holiday.component';

const routes: Routes = [
    {
        path: '',
        component: HolidayComponent
    },
];

export const HolidayRoutes = RouterModule.forChild(routes);
